import React from "react";
import { Box, Button, GlobalStyles, Stack, Typography } from "@mui/material";

export const StickyFormActions = ({
  hasChanges,
  saving,
  disabled = false,
  saveText = "Save",
  onCancel,
  onSave,
}) => (
  <>
    {/* lift the global toast (PreloadContext) above the sticky action bar while this form is shown */}
    <GlobalStyles
      styles={(theme) => ({
        ".MuiSnackbar-root.MuiSnackbar-anchorOriginBottomRight": {
          bottom: 152,
          [theme.breakpoints.up("sm")]: { bottom: 80 },
        },
      })}
    />
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 1,
        mt: 3,
        py: 1.5,
        px: 2,
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 1.5,
      }}
    >
      <Typography
        role="status"
        variant="body2"
        color="text.secondary"
        sx={{ pl: { sm: 1 } }}
      >
        {hasChanges ? "You have unsaved changes" : "No changes to save"}
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        sx={{ "& .MuiButton-root": { width: { xs: "100%", sm: "auto" } } }}
      >
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!hasChanges || disabled}
          loading={saving}
          onClick={onSave}
        >
          {saveText}
        </Button>
      </Stack>
    </Box>
  </>
);
